/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerAzureOpenAiAssistantCreate
 */
export interface SingleTurnChatInferencerAzureOpenAiAssistantCreate {
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  name: string;
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  assistantId: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  assistantEndpoint: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  assistantApiVersion: string;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerAzureOpenAiAssistantCreate interface.
 */
export function instanceOfSingleTurnChatInferencerAzureOpenAiAssistantCreate(
  value: object,
): value is SingleTurnChatInferencerAzureOpenAiAssistantCreate {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  if (!('assistantEndpoint' in value) || value['assistantEndpoint'] === undefined) return false;
  if (!('assistantApiVersion' in value) || value['assistantApiVersion'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerAzureOpenAiAssistantCreateFromJSON(
  json: any,
): SingleTurnChatInferencerAzureOpenAiAssistantCreate {
  return SingleTurnChatInferencerAzureOpenAiAssistantCreateFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerAzureOpenAiAssistantCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerAzureOpenAiAssistantCreate {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
    assistantEndpoint: json['assistant_endpoint'],
    assistantApiVersion: json['assistant_api_version'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function SingleTurnChatInferencerAzureOpenAiAssistantCreateToJSON(
  value?: SingleTurnChatInferencerAzureOpenAiAssistantCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
    assistant_endpoint: value['assistantEndpoint'],
    assistant_api_version: value['assistantApiVersion'],
    credential_id: value['credentialId'],
  };
}
